import { Components, Theme } from '@mui/material'

const MuiPaper: Components<Theme>['MuiPaper'] = {
  styleOverrides: {
    elevation8: () => ({
      background: `none`,
      border: `none`,
      boxShadow: `none`,
      borderRadius: 14,
      width: '200px',
    }),
  },
}

export default MuiPaper
